import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router'
import { RuntimeListPage } from '@/features/runtimes/runtime-list-page'
import { validateRuntimeSearch } from '@/features/runtimes/runtime-model'
export const Route = createFileRoute('/_console/runtimes/')({ validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => validateRuntimeSearch(search), component: RuntimesRoute })
function RuntimesRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return <RuntimeListPage search={search} onSearchChange={next => { void navigate({ search: next, replace: true }) }} />
}
